import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FlameMatrix from './FlameMatrix';
import { ethers } from 'ethers';

const BURN_WALLET = '0x000000000000000000000000000000000000dEaD';
const TOKEN_CONTRACT = '0xA6D7137aF64280e3eb8715aB6766740984Dd35E7';
const DOGECHAIN_RPC = 'https://rpc.dogechain.dog';

const CountdownOverlay = ({ onUnlock }) => {
  const [password, setPassword] = useState('');
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [burnStats, setBurnStats] = useState({
    burnedAmount: ethers.BigNumber.from(0),
    percentage: '0'
  });

  // Utility function to format balance in trillions
  const formatBalance = (balance, fullNumber = false) => {
    try {
      if (!balance) return fullNumber ? '0' : '0.00 T';

      // Convert the balance to a string using ethers.js
      const rawNumber = ethers.utils.formatEther(balance);

      if (fullNumber) {
        // Format as a whole number with commas
        return rawNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      // Format in trillions with 2 decimal places
      const inTrillions = ethers.utils.formatUnits(balance, 12);
      return `${inTrillions} T`;
    } catch (error) {
      console.error('Error formatting balance:', error);
      return fullNumber ? '0' : '0.00 T';
    }
  };

  useEffect(() => {
    const fetchBurnStats = async () => {
      try {
        const provider = new ethers.providers.JsonRpcProvider(DOGECHAIN_RPC);
        const minABI = [
          {
            constant: true,
            inputs: [{ name: "_owner", type: "address" }],
            name: "balanceOf",
            outputs: [{ name: "balance", type: "uint256" }],
            type: "function",
          },
          {
            constant: true,
            inputs: [],
            name: "totalSupply",
            outputs: [{ name: "", type: "uint256" }],
            type: "function",
          }
        ];

        const contract = new ethers.Contract(TOKEN_CONTRACT, minABI, provider);
        const [burnBalance, totalSupply] = await Promise.all([
          contract.balanceOf(BURN_WALLET).catch(() => ethers.BigNumber.from(0)),
          contract.totalSupply().catch(() => ethers.BigNumber.from(0))
        ]);

        const burnedAmount = burnBalance;
        const percentage = totalSupply.gt(0) 
          ? (burnBalance.mul(100).div(totalSupply).toString())
          : '0';

        setBurnStats({ burnedAmount, percentage });
      } catch (error) {
        console.error('Error fetching burn stats:', error);
        setBurnStats({ burnedAmount: ethers.BigNumber.from(0), percentage: '0' });
      }
    };

    fetchBurnStats();
    const interval = setInterval(fetchBurnStats, 30000); // Update every 30 seconds
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // January 11, 2025 at 4:20 PM EST
    const targetDate = new Date('2025-01-11T16:20:00-05:00');

    const updateCountdown = () => {
      const now = new Date();
      const difference = targetDate - now;

      if (difference <= 0) {
        onUnlock();
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    };

    const timer = setInterval(updateCountdown, 1000);
    updateCountdown();

    return () => clearInterval(timer);
  }, [onUnlock]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === 'kdu6969!') {
      onUnlock();
    }
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US').format(num);
  };

  return null;
};

CountdownOverlay.propTypes = {
  onUnlock: PropTypes.func.isRequired
};

export default CountdownOverlay;